import React, {Component} from 'react';
import './PlainDialog.css';

const getButtonHandler = (item, props) =>
	props['on' + item.substring(0, 1).toUpperCase() + item.substring(1).replace(/ /g, '')];

class PlainDialog extends Component {
	handleKey = e => {
		if (e.key === 'Escape') {
			this.props.onCancel();
		} else if (e.key === 'Enter' && this.props.submitOnEnter) {
			if (this.props.onSave && (!this.props.disabled || !this.props.disabled['save'])) {
				this.props.onSave();
			} else if (this.props.buttons && this.props.buttons.length > 1) {
				// assumes the positive action is always stored as the 2nd item or uses the emphasis
				if (
					!this.props.disabled ||
					(this.props.disabled &&
						!this.props.disabled[this.props.emphasis || this.props.buttons[1]])
				) {
					getButtonHandler(this.props.emphasis || this.props.buttons[1], this.props)();
				}
			}
		}
	};

	componentDidMount() {
		this.dialogEl.focus(); // auto draw focus when mounted
		document.addEventListener('keydown', this.handleKey, false);
	}
	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKey, false);
	}

	render() {
		const {
			className,
			emphasis = 'save',
			title,
			disabled = {},
			buttons = ['cancel', 'save'],
			onSave,
			onCancel,
			children
		} = this.props;

		return (
			<dialog className={`Dialog ${className}`} open={true} ref={el => (this.dialogEl = el)}>
				<button onClick={onCancel} className="close-btn">
					<span className="icon icon-close" />
				</button>
				<section className="Dialog-body">{children}</section>
			</dialog>
		);
	}
}

PlainDialog.defaultProps = {
	submitOnEnter: true
};

export default PlainDialog;



// WEBPACK FOOTER //
// ./src/widgets/PlainDialog.js